import { InterWebviewBridge } from 'core/InterWebviewBridge';
import { WbHttpActions, WbHttpMethods } from 'enums';
/**
 * Função que permite fazer requisições usando o CA
 */
const InterWbHttp = () => {
    const iWb = InterWebviewBridge.getInstance();
    return {
        /**
         * Executa um get usando a CA
         * @param endpoint - endereço da requisição
         * @param headers - Headers Record<string,sring>
         * @param options - IWHttpOptions
         * @returns IWbHttpData
         */
        get(config) {
            const { endpoint, headers = {}, options = {} } = config;
            return iWb.execute({
                action: WbHttpActions.REQUEST_API,
                metadata: {
                    method: WbHttpMethods.GET,
                    endpoint,
                    headers: headers,
                    options: options,
                    engine: 'CA',
                    ...(config.org && { org: config.org }),
                },
            });
        },
        /**
         * Executa um post usando a CA
         *
         * @param endpoint - endereço da requisição
         * @param headers - Headers Record<string,sring>
         * @param body - body da requisição Record<string,unknown>
         * @param options - IWHttpOptions
         * @returns IWbHttpData
         */
        post(config) {
            const { endpoint, body, headers = {}, options = {} } = config;
            return iWb.execute({
                action: WbHttpActions.REQUEST_API,
                metadata: {
                    method: WbHttpMethods.POST,
                    endpoint,
                    body,
                    headers: headers,
                    options: options,
                    engine: 'CA',
                    ...(config.org && { org: config.org }),
                },
            });
        },
        /**
         * Executa um put usando a CA
         *
         * @param endpoint - endereço da requisição
         * @param headers - Headers Record<string,sring>
         * @param body - body da requisição Record<string,unknown>
         * @param options - IWHttpOptions
         * @returns IWbHttpData
         */
        put(config) {
            const { endpoint, body, headers = {}, options = {} } = config;
            return iWb.execute({
                action: WbHttpActions.REQUEST_API,
                metadata: {
                    method: WbHttpMethods.PUT,
                    endpoint,
                    body,
                    headers: headers,
                    options: options,
                    engine: 'CA',
                    ...(config.org && { org: config.org }),
                },
            });
        },
        /**
         * Executa um delete usando a CA
         *
         * @param endpoint - endereço da requisição
         * @param headers - Headers Record<string,sring>
         * @param options - IWHttpOptions
         * @returns IWbHttpData
         */
        delete(config) {
            const { endpoint, headers = {}, options = {} } = config;
            return iWb.execute({
                action: WbHttpActions.REQUEST_API,
                metadata: {
                    method: WbHttpMethods.DELETE,
                    endpoint,
                    headers: headers,
                    options: options,
                    engine: 'CA',
                    ...(config.org && { org: config.org }),
                },
            });
        },
    };
};
export const interWbHttp = InterWbHttp();
